module.exports = __webpack_public_path__ + "static/media/WorldWideWeb.66abf972.webp";